import { Divider, Form, Input } from 'antd'
import { tabFields } from '~app/configuration/labels'
import type { AutoFocusedFields } from '~app/hooks/useField'
import i18n from '~app/i18n/i18n'

export interface Sender {
  name?: string
  email?: string
  phone?: string
}

interface Props {
  senderFields: AutoFocusedFields<Sender>
}

const DocumentSender = ({ senderFields }: Props) => {
  const { name, email, phone } = senderFields

  return (
    <>
      <Divider
        orientation="left"
        orientationMargin={0}
        style={{ margin: '8px 0' }}
      >
        {i18n.t('documentView.sender')}
      </Divider>
      <Form.Item label="Name" style={{ marginBottom: 8 }}>
        <Input
          {...name.inputField}
          placeholder={i18n.t('documentView.unknown')}
          tabIndex={tabFields.senderName}
        />
      </Form.Item>
      <Form.Item
        label={i18n.t('documentView.email')}
        style={{ marginBottom: 8 }}
      >
        <Input {...email.inputField} tabIndex={tabFields.senderEmail} />
      </Form.Item>
      <Form.Item
        label={i18n.t('documentView.phone')}
        style={{ marginBottom: 8 }}
      >
        <Input
          {...phone.inputField}
          placeholder={i18n.t('documentView.phone')}
          tabIndex={tabFields.senderPhone}
        />
      </Form.Item>
    </>
  )
}

export default DocumentSender
